import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  textarea: {
    maxHeight: 66,
    height: '66px !important'
  },
  card: {
    background: `${token.primary.primary3}1A`,
    border: `1px solid ${token.colorSplit}`,
    marginBottom: 16,
    borderRadius: 6,
    padding: 16
  },
  verticalDivider: {
    marginInline: 0,
    height: 16,
    borderColor: `${token.grey.grey1} !important`
  },
  caseTextarea: {
    maxHeight: 110,
    height: '110px !important'
  }
}))
